import {Modal} from 'antd';
import React, {useState} from 'react';
import {XIcon} from '../SvgIcons/SvgIcons';
import CancelOfferModal from './CancelOfferModal';

const CancelIntro = ({firstName, lastName, handleVisibleCancel, offerId}) => {
  const [modalVisible, setModalVisible] = useState(false);

  const showModal = () => {
    setModalVisible(true);
    handleVisibleCancel();
  };

  const handleOK = () => {
    setModalVisible(false);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  return (
    <>
      <div className="cancel-intro" onClick={showModal}>
        <XIcon />
        <p>Cancel intro</p>
      </div>
      <Modal
        className="modal-body"
        footer={null}
        closable={false}
        onCancel={handleCancel}
        onOk={handleOK}
        visible={modalVisible}>
        <CancelOfferModal
          handleCancel={handleCancel}
          firstName={firstName}
          lastName={lastName}
          offerId={offerId}
        />
      </Modal>
    </>
  );
};

export default CancelIntro;
